import { throttle as throttleFn } from "lodash-es";

export interface ThrottleOptions {
	leading?: boolean;
	trailing?: boolean;
}

export const throttle =
	(wait?: number, options?: ThrottleOptions) =>
	(_target: object, _propertyKey: string, descriptor: PropertyDescriptor) => {
		const originalMethod = descriptor.value;
		descriptor.value = throttleFn(originalMethod, wait, options);
		return descriptor;
	};
